import { Box } from '@mui/material';

import { ThinkingIndicator } from '../../thinking-indicator.component';

export const ThinkingMessage = () => (
  <Box
    sx={{
      width: '100%',
    }}
  >
    <ThinkingIndicator />
  </Box>
);
